import { useState } from 'react';
import { aboutFaqs } from '@/mocks/about';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full py-10 md:py-20 bg-white relative overflow-hidden scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8 relative z-10">
        <h2 className="text-center text-3xl md:text-4xl font-black text-primary-500 mb-3">Frequently Asked Questions</h2>
        <p className="text-center text-foreground-700 text-base md:text-lg mb-8 md:mb-10 max-w-2xl mx-auto">
          Everything you need to know about Gracie & Lily Adventures.
        </p>

        <div className="flex flex-col gap-3">
          {aboutFaqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.question}
                className={`rounded-2xl overflow-hidden transition-colors ${isOpen ? 'bg-primary-100' : 'bg-background-100'}`}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="font-extrabold text-foreground-900 text-sm md:text-base">
                    {faq.question}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center shrink-0">
                    <i
                      className={`ri-add-line text-xl text-primary-500 transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`}
                    ></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-foreground-700 text-sm md:text-base leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-8 md:mt-10 text-center">
          <p className="text-foreground-700 text-sm mb-2">Still have questions?</p>
          <a
            href="mailto:hello@gracieandlily.com"
            className="inline-flex items-center gap-2 bg-primary-500 text-white px-6 py-3 rounded-lg font-bold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-700 transition-colors"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-line text-base"></i>
            </span>
            Email hello@gracieandlily.com
          </a>
        </div>
      </div>
    </section>
  );
}